///taskchecklisttemplate/list/active
export const CHECKLIST_TEMPLATE_LIST_ACTIVE = "CHECKLIST_TEMPLATE_LIST_ACTIVE";
export const CHECKLIST_TEMPLATE_LIST_ACTIVE_SUCCESS =
  "CHECKLIST_TEMPLATE_LIST_ACTIVE_SUCCESS";
export const CHECKLIST_TEMPLATE_LIST_ACTIVE_FAILURE =
  "CHECKLIST_TEMPLATE_LIST_ACTIVE_FAILURE";

///taskchecklisttemplate/assigntotask
export const CHECKLIST_TEMPLATE_ASSIGN_TO_TASK =
  "CHECKLIST_TEMPLATE_ASSIGN_TO_TASK";
export const CHECKLIST_TEMPLATE_ASSIGN_TO_TASK_SUCCESS =
  "CHECKLIST_TEMPLATE_ASSIGN_TO_TASK_SUCCESS";
export const CHECKLIST_TEMPLATE_ASSIGN_TO_TASK_FAILURE =
  "CHECKLIST_TEMPLATE_ASSIGN_TO_TASK_FAILURE";

///taskchecklist/search
export const CHECKLIST_SEARCH = "CHECKLIST_SEARCH";
export const CHECKLIST_SEARCH_SUCCESS = "CHECKLIST_SEARCH_SUCCESS";
export const CHECKLIST_SEARCH_FAILURE = "CHECKLIST_SEARCH_FAILURE";

///taskchecklist/data/
export const CHECKLIST_DATA = "CHECKLIST_DATA";
export const CHECKLIST_DATA_SUCCESS = "CHECKLIST_DATA_SUCCESS";
export const CHECKLIST_DATA_FAILURE = "CHECKLIST_DATA_FAILURE";

////taskchecklist/update
export const CHECKLIST_UPDATE = "CHECKLIST_UPDATE";
export const CHECKLIST_UPDATE_SUCCESS = "CHECKLIST_UPDATE_SUCCESS";
export const CHECKLIST_UPDATE_FAILURE = "CHECKLIST_UPDATE_FAILURE";
///taskchecklist/pdfsheet/
export const CHECKLIST_PDF_SHEET = "CHECKLIST_PDF_SHEET";
export const CHECKLIST_PDF_SHEET_SUCCESS = "CHECKLIST_PDF_SHEET_SUCCESS";
export const CHECKLIST_PDF_SHEET_FAILURE = "CHECKLIST_PDF_SHEET_FAILURE";
//Delete Task Checklist
export const DELETE_TASK_CHECKLIST = "DELETE_TASK_CHECKLIST";
export const DELETE_TASK_CHECKLIST_SUCCESS = "DELETE_TASK_CHECKLIST_SUCCESS";
export const DELETE_TASK_CHECKLIST_FAILURE = "DELETE_TASK_CHECKLIST_FAILURE";
///taskchecklist/data/mergewithtemplate
export const CHECKLIST_MERGE_WITH_TEMPLATE = "CHECKLIST_MERGE_WITH_TEMPLATE";
export const CHECKLIST_MERGE_WITH_TEMPLATE_SUCCESS =
  "CHECKLIST_MERGE_WITH_TEMPLATE_SUCCESS";
export const CHECKLIST_MERGE_WITH_TEMPLATE_FAILURE =
  "CHECKLIST_MERGE_WITH_TEMPLATE_FAILURE";
///taskchecklist/search
export const TASK_CHECKLIST_SEARCH = "TASK_CHECKLIST_SEARCH";
export const TASK_CHECKLIST_SEARCH_SUCCESS = "TASK_CHECKLIST_SEARCH_SUCCESS";
export const TASK_CHECKLIST_SEARCH_FAILURE = "TASK_CHECKLIST_SEARCH_FAILURE";
///taskchecklist/list
export const TASK_CHECKLIST_LIST = "TASK_CHECKLIST_LIST";
export const TASK_CHECKLIST_LIST_SUCCESS = "TASK_CHECKLIST_LIST_SUCCESS";
export const TASK_CHECKLIST_LIST_FAILURE = "TASK_CHECKLIST_LIST_FAILURE";
///taskchecklist/pdfsheet/debug/ data
export const CHECKLIST_PDF_SHEET_DEBUG = "CHECKLIST_PDF_SHEET_DEBUG";
export const CHECKLIST_PDF_SHEET_DEBUG_SUCCESS =
  "CHECKLIST_PDF_SHEET_DEBUG_SUCCESS";
export const CHECKLIST_PDF_SHEET_DEBUG_FAILURE =
  "CHECKLIST_PDF_SHEET_DEBUG_FAILURE";

///taskchecklisttemplate/create
export const CREATE_CHECKLIST_TEMPLATE = "CREATE_CHECKLIST_TEMPLATE";
export const CREATE_CHECKLIST_TEMPLATE_SUCCESS =
  "CREATE_CHECKLIST_TEMPLATE_SUCCESS";
export const CREATE_CHECKLIST_TEMPLATE_FAILURE =
  "CREATE_CHECKLIST_TEMPLATE_FAILURE";

///taskchecklisttemplate/update
export const UPDATE_CHECKLIST_TEMPLATE = "UPDATE_CHECKLIST_TEMPLATE";
export const UPDATE_CHECKLIST_TEMPLATE_SUCCESS =
  "UPDATE_CHECKLIST_TEMPLATE_SUCCESS";
export const UPDATE_CHECKLIST_TEMPLATE_FAILURE =
  "UPDATE_CHECKLIST_TEMPLATE_FAILURE";

///taskchecklisttemplate/clone
export const CLONE_CHECKLIST_TEMPLATE = "CLONE_CHECKLIST_TEMPLATE";
export const CLONE_CHECKLIST_TEMPLATE_SUCCESS =
  "CLONE_CHECKLIST_TEMPLATE_SUCCESS";
export const CLONE_CHECKLIST_TEMPLATE_FAILURE =
  "CLONE_CHECKLIST_TEMPLATE_FAILURE";

///taskchecklisttemplate/datatype/list
export const CHECKLIST_TEMPLATE_DATATYPE_LIST =
  "CHECKLIST_TEMPLATE_DATATYPE_LIST";
export const CHECKLIST_TEMPLATE_DATATYPE_LIST_SUCCESS =
  "CHECKLIST_TEMPLATE_DATATYPE_LIST_SUCCESS";
export const CHECKLIST_TEMPLATE_DATATYPE_LIST_FAILURE =
  "CHECKLIST_TEMPLATE_DATATYPE_LIST_FAILURE";

///taskchecklisttemplate/systemfield/list
export const CHECKLIST_TEMPLATE_SYSTEMFIELD_LIST =
  "CHECKLIST_TEMPLATE_SYSTEMFIELD_LIST";
export const CHECKLIST_TEMPLATE_SYSTEMFIELD_LIST_SUCCESS =
  "CHECKLIST_TEMPLATE_SYSTEMFIELD_LIST_SUCCESS";
export const CHECKLIST_TEMPLATE_SYSTEMFIELD_LIST_FAILURE =
  "CHECKLIST_TEMPLATE_SYSTEMFIELD_LIST_FAILURE";

///taskchecklisttemplate/pdftheme/list
export const CHECKLIST_TEMPLATE_PDFTHEME_LIST =
  "CHECKLIST_TEMPLATE_PDFTHEME_LIST";
export const CHECKLIST_TEMPLATE_PDFTHEME_LIST_SUCCESS =
  "CHECKLIST_TEMPLATE_PDFTHEME_LIST_SUCCESS";
export const CHECKLIST_TEMPLATE_PDFTHEME_LIST_FAILURE =
  "CHECKLIST_TEMPLATE_PDFTHEME_LIST_FAILURE";
